import React from "react";

const Rows = React.memo(function Rows({ items, limit = 10000 }) {
  return items.slice(0, limit).map((it, idx) => (
    <tr key={idx} style={{
      transition: "all 0.2s ease",
      cursor: "default"
    }}>
      <td style={{ whiteSpace: "nowrap" }}>{it.referenceNo}</td>
      <td>{it.productDescription}</td>
      <td style={{ textAlign: "center" }}>{it.warehouse}</td>
      <td style={{ textAlign: "right" }}>{it.quantity}</td>
      <td style={{ textAlign: "center" }}>{it.unit}</td>
      <td style={{ textAlign: "right" }}>{it.price}</td>
    </tr>
  ));
});

export default function PreviewImportModal({
  items = [],
  uploadFilename = "",
  drHeader = {},
  onCancel,
  onConfirm,
  tableMaxHeight = 600,
  tableMaxWidth = 600,
}) {
  const {
    drNo = "",
    drDate = "",
    drType = "",
    docType = "",
    remarks = "",
  } = drHeader || {};

  const InfoField = ({ icon, label, value }) => (
    <div style={{
      background: "#F9FAFB",
      border: "1px solid #E5E7EB",
      borderRadius: "8px",
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
      gap: "12px"
    }}>
      <div style={{
        width: "36px",
        height: "36px",
        borderRadius: "8px",
        background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      }}>
        <i className={icon} style={{ fontSize: "1rem", color: "#fff" }}></i>
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: "0.7rem", color: "#6B7280", fontWeight: "600", marginBottom: "2px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
          {label}
        </div>
        <div style={{ fontSize: "0.875rem", color: "#111827", fontWeight: "600", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {value || "—"}
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ 
      background: "#fff", 
      width: "90vw",
      maxWidth: "1400px",
      borderRadius: "12px",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)"
    }}>
      <div style={{
        background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
        padding: "24px",
        borderRadius: "12px 12px 0 0",
        marginBottom: "24px"
      }}>
        <div className="d-flex align-items-center gap-3">
          <div style={{
            width: "56px",
            height: "56px",
            borderRadius: "12px",
            background: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            <i className="bi bi-file-earmark-spreadsheet-fill" style={{ fontSize: "1.75rem", color: "#fff" }}></i>
          </div>
          <div style={{ flex: 1 }}>
            <h5 style={{ margin: 0, color: "#fff", fontWeight: "700", fontSize: "1.25rem" }}>
              Preview Import Data
            </h5>
            <div style={{ color: "rgba(255, 255, 255, 0.9)", fontSize: "0.875rem", marginTop: "4px" }}>
              <i className="bi bi-file-text me-2"></i>
              {uploadFilename || "Imported File"}
              <span style={{
                marginLeft: "16px",
                padding: "2px 12px",
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "12px",
                fontSize: "0.8rem",
                fontWeight: "600"
              }}>
                {items.length} rows
              </span>
            </div>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 24px 24px" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px"
        }}>
          <i className="bi bi-info-circle-fill" style={{ fontSize: "1.125rem", color: "#83c14a" }}></i>
          <h6 style={{ margin: 0, fontSize: "0.95rem", fontWeight: "700", color: "#111827" }}>
            Document Information
          </h6>
        </div>

        <div className="row g-3 mb-4">
          <div className="col-md-4">
            <InfoField icon="bi bi-hash" label="DR Number" value={drNo} />
          </div>
          <div className="col-md-4">
            <InfoField icon="bi bi-calendar3" label="Date" value={drDate} />
          </div>
          <div className="col-md-4">
            <InfoField icon="bi bi-tag-fill" label="DR Type" value={drType} />
          </div>
          <div className="col-md-6">
            <InfoField icon="bi bi-file-text-fill" label="Document Type" value={docType} />
          </div>
          <div className="col-md-6">
            <InfoField icon="bi bi-chat-left-text-fill" label="Remarks" value={remarks} />
          </div>
        </div>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px"
        }}>
          <i className="bi bi-table" style={{ fontSize: "1.125rem", color: "#83c14a" }}></i>
          <h6 style={{ margin: 0, fontSize: "0.95rem", fontWeight: "700", color: "#111827" }}>
            Items Preview
          </h6>
        </div>

        <div
          style={{
            maxHeight: tableMaxHeight,
            overflow: "auto",
            border: "1px solid #E5E7EB",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
          }}
        >
          <table className="table table-sm mb-0" style={{ fontSize: "0.875rem", width: "100%" }}>
            <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
              <tr style={{ background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                <th style={{ color: "#fff", fontWeight: "700", border: "none", padding: "14px 12px", whiteSpace: "nowrap", position: "sticky", top: 0, background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                  <i className="bi bi-hash me-2"></i>Reference No
                </th>
                <th style={{ color: "#fff", fontWeight: "700", border: "none", padding: "14px 12px", minWidth: "200px", position: "sticky", top: 0, background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                  <i className="bi bi-box-seam me-2"></i>Description
                </th>
                <th style={{ color: "#fff", fontWeight: "700", border: "none", padding: "14px 12px", textAlign: "center", position: "sticky", top: 0, background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                  <i className="bi bi-building me-2"></i>Whse
                </th>
                <th style={{ color: "#fff", fontWeight: "700", border: "none", padding: "14px 12px", textAlign: "right", position: "sticky", top: 0, background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                  <i className="bi bi-123 me-2"></i>Qty
                </th>
                <th style={{ color: "#fff", fontWeight: "700", border: "none", padding: "14px 12px", textAlign: "center", position: "sticky", top: 0, background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                  <i className="bi bi-rulers me-2"></i>Unit
                </th>
                <th style={{ color: "#fff", fontWeight: "700", border: "none", padding: "14px 12px", textAlign: "right", position: "sticky", top: 0, background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)" }}>
                  <i className="bi bi-currency-dollar me-2"></i>Price
                </th>
              </tr>
            </thead>
            <tbody>
              <Rows items={items} />
            </tbody>
          </table>
        </div>

        <div className="d-flex gap-3 mt-4">
          <button 
            className="btn btn-light" 
            onClick={onCancel}
            style={{
              padding: "12px 24px",
              fontWeight: "600",
              border: "1px solid #E5E7EB",
              borderRadius: "8px",
              transition: "all 0.2s ease"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#F9FAFB";
              e.target.style.borderColor = "#D1D5DB";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#fff";
              e.target.style.borderColor = "#E5E7EB";
            }}
          >
            <i className="bi bi-x-circle me-2"></i>
            Cancel
          </button>
          <button
            className="btn text-white"
            style={{
              background: "linear-gradient(135deg, #83c14a 0%, #6fa83d 100%)",
              padding: "12px 24px",
              fontWeight: "700",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(131, 193, 74, 0.3)",
              transition: "all 0.2s ease",
              flex: 1
            }}
            onClick={onConfirm}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 16px rgba(131, 193, 74, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 12px rgba(131, 193, 74, 0.3)";
            }}
          >
            <i className="bi bi-check-circle-fill me-2"></i>
            Import All {items.length} Items
          </button>
        </div>
      </div>
    </div>
  );
}
